import { Injectable } from '@angular/core';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import * as content from '../../assets/data/content.json';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  content: Object;

  constructor() { 
    this.content = content;
  }

  getTitle() {
    return content.title;
  }

  getHeaderLogo() {
    return content.headerLogo;
  }

  getHeaderExtraLogo() {
    return content.heaerExtraLogo;
  }

  getHomePageUrl() {
    return content.homePageUrl;
  }

  getAllRouteNames() {
    return content.pages.map(page => page.name.url)
  }

  getMenuItems() {
    return content.pages.map(page => page.name)
  }

  getPageContentByUrl(url:string) {
    return content.pages.filter(page => page.name.url === url)[0];
  }

  getFooterRow() {
    return content.footer;
  }
/*
  getContentItemsByIds(ids: string[]) {
    const contentItems = content.content;

    const itemsFound = contentItems.filter(item => 
      ids.includes(item.id)
    )

    return itemsFound;
  }
*/

}
